import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import ajax from "superagent";
import { PageConfigurationContextConsumer } from "./index";
// @ts-ignore
import getCroppedImg from "./cropImage";
import "./styles/banner-crop.css";

const HeaderBannerCropper = ({
  bannerURL,
  coversS3Bucket,
  bannerS3BasePath,
  cropFinished,
  cancelCrop
}: {
  bannerURL: string;
  coversS3Bucket: string;
  bannerS3BasePath: string;
  cropFinished: (croppedBannerURL: string) => void;
  cancelCrop: () => void;
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [uploading, setUploading] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({});
  const onCropComplete = useCallback((_, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  const uploadAndSave = async () => {
    setUploading(true);
    ajax
      .post("/s3/upload_image")
      .attach("file", await getCroppedImg(bannerURL, croppedAreaPixels, 0))
      .field("bucket", coversS3Bucket)
      .field(
        "objectKey",
        `${bannerS3BasePath}/cropped_${Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, "")
          .substr(0, 5)}`
      )
      .then(response => {
        setUploading(false);
        cropFinished(response.body.url);
      })
      .catch(_ => {
        setUploading(false);
        // @ts-ignore
        toastr.error(
          "There was an error saving your cropped banner. Please try again."
        );
      });
  };

  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <div>
            <div className="modal fade in banner-crop-dialog" role="dialog">
              <div className="modal-dialog banner-crop-dialog-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    onClick={cancelCrop}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 className="modal-title">Adjust the banner image</h4>
                </div>
                <div className="modal-body">
                  {uploading && <div className="crop-blocker"></div>}
                  <Cropper
                    image={bannerURL}
                    crop={crop}
                    zoom={zoom}
                    aspect={1440 / 225}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    showGrid={false}
                    classes={{ cropAreaClassName: "cropper" }}
                    style={{
                      containerStyle: { height: 400, position: "relative" }
                    }}
                  />
                  <div className="banner-crop-info">
                    Click and drag to reposition and scroll to zoom
                    <br />
                    <small>Min image size: 1200 x 250px</small>
                  </div>
                </div>
                <div className="modal-footer geo-modal__actions">
                  <a
                    className="cancel-crop"
                    style={{
                      color: `${pageConfiguration.primaryColor}`
                    }}
                    onClick={_ => cancelCrop()}
                  >
                    Cancel
                  </a>
                  <button
                    className="btn btn-primary btn-round pull-right"
                    style={{
                      backgroundColor: `${pageConfiguration.primaryColor}`,
                      border: "none"
                    }}
                    onClick={_ => uploadAndSave()}
                  >
                    {uploading ? (
                      <span>
                        <span className="fa fa-circle-o-notch fa-spin" />
                        &nbsp; Applying
                      </span>
                    ) : (
                      "Apply"
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade in" />
          </div>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default HeaderBannerCropper;
